<template>
    <svg
        class="icon-code"
        :class="iconClasses"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="currentColor"
    >
        <path
            d="M5.854 4.854a.5.5 0 1 0-.708-.708l-3.5 3.5a.5.5 0 0 0 0 .708l3.5 3.5a.5.5 0 0 0 .708-.708L2.707 8zm4.292 0a.5.5 0 0 1 .708-.708l3.5 3.5a.5.5 0 0 1 0 .708l-3.5 3.5a.5.5 0 0 1-.708-.708L13.293 8z"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconCode',
    props: {
        size: {
            required: false,
            type: Number,
            default: 4,
        },
        marginAuto: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    computed: {
        iconClasses() {
            const cls = {};
            cls[`h-${this.size} w-${this.size}`] = true;
            cls['m-auto'] = !!this.marginAuto;
            return cls;
        },
    },
};
</script>
